import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { deepCopy, removeUndefined } from 'diwimamodelweb/lib/utils/obejct-diff';
import { gOLineTypesSettingForm } from '../model/form';
import  { GeoObjLineTypesData, NetworkConstants }  from 'diwimamodelweb/lib';
import { UserFeedbackService } from '../user-feedback.service';
import { validColorValidator } from 'ngx-colors';
import { firstValueFrom, skipWhile, take } from 'rxjs';
import { SettingsService } from '../settings.service';

@Component({
  selector: 'app-geo-object-line-types-setting-form',
  templateUrl: './geo-object-line-types-setting-form.component.html',
  styleUrls: ['./geo-object-line-types-setting-form.component.css', '../../app.component.scss']
})
export class GeoObjectLineTypesSettingFormComponent implements OnInit {

  @Input() data: gOLineTypesSettingForm
  @Input() formBuilder: FormBuilder
  @Input() translateService: TranslateService
  
  newChanges = false
  gOLineTypesForm: FormGroup
  isCreate=false
  oldGeoObjectLine: GeoObjLineTypesData
  lineColorNameOpacity:number
  lineColorNameData:string
  newAvalue:string
  updateRight = false
  deleteRight = false

  constructor(
    private userFeedbackService: UserFeedbackService,
    private settingsService : SettingsService
  ) { }

  async ngOnInit(): Promise<void> {

    const context = await firstValueFrom(this.settingsService.selectedUserContext$.pipe(
      skipWhile(el => !el),
      take(1)
    ))
    const rights = this.settingsService.rightsPercontext.get(context.identifier)
    this.updateRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['U'] ?? false
    this.deleteRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['D'] ?? false
    if (!this.data.data) this.isCreate = true
   
    this.gOLineTypesForm = this.formBuilder.group({
      title: [, Validators.required],
      lineColorName: [ , [Validators.required, validColorValidator()]],
      // lineColorNameOpacity: [1],
      lineWidth:[1, Validators.required],
      additionalObjects: [false],
      testInterval: [false],
      usageInformation: [false],
      notificationChannel: [false],
      sortIndex: [0]
    })

    if(this.data.data) {
      this.isCreate=false
      this.oldGeoObjectLine = deepCopy(this.data.data)
      this.initilizeWithData()
    }
 
    this.gOLineTypesForm.valueChanges.subscribe( (value) =>{
        this.lineColorNameData = value.lineColorName
        if(!this.isCreate){
          const {title, lineColorName, lineColorNameOpacity, lineWidth, testinterval, usageInformation} = value
          let anyObj = {
            title, lineColorName, lineColorNameOpacity, lineWidth, testinterval, usageInformation
          }
          this.newChanges=true
        }
      } 
    )
  }

  numberToHex(n){
    if(n<1){
      const nhex=n.toString(16)
      this.newAvalue=nhex.slice(2,4) 
    }
    if(n==1){
      this.newAvalue=""
    }
    if(n==0){
      this.newAvalue="00"
    }
    if(!n){
      this.newAvalue = ''
      this.gOLineTypesForm.patchValue({lineColorNameOpacity: 1})
    }
  }

  initilizeWithData(){
    this.lineColorNameData = this.data.data.lineColorName
    var {title, lineColorName ,lineWidth }= this.data.data
   
    if (!this.data.data.lineWidth){
      lineWidth=0
    }

    const { displayOptions } = this.data.data
    const { usageInformation, testInterval, notificationChannel } = displayOptions ?? {}
    this.gOLineTypesForm.patchValue({ 
      title,lineColorName: lineColorName ? lineColorName : undefined, lineWidth, 
      usageInformation: usageInformation ? usageInformation : undefined,
      testInterval: testInterval ? testInterval : undefined,
      notificationChannel: notificationChannel ? notificationChannel : undefined })
  }

  onSubmit(){
    let {title, lineColorName, lineWidth,usageInformation, testInterval, notificationChannel, sortIndex } = this.gOLineTypesForm.value
    let color
    
    if(lineColorName){
      color = lineColorName
    }else{
      color = undefined
    }

    if(color?.includes('undefined'))
      color.replaceAll('undefined','')

    if(this.isCreate){
      var lineNumber: number = +lineWidth
      let setting: any = {
        title, identifier: title.toLowerCase(), 
        lineColorName:color,
        lineWidth: lineNumber,
         sortIndex,
        displayOptions:{
          usageInformation, testInterval, notificationChannel
        }
      }
       const cleaned = removeUndefined(setting)
       this.data.onCreate(cleaned)
    }else{
      let displayOptions: any = {
        usageInformation, testInterval, notificationChannel
      }
      var lineNumber: number = +lineWidth

      this.data.data.title = title
      if(color)
        this.data.data.lineColorName = color
      this.data.data.lineWidth = lineWidth

      this.data.data.displayOptions = displayOptions
      removeUndefined(this.data.data)
      this.data.onSubmit()

    }
  }


  async onDelete(){
    if(!this.isCreate){
      this.data.onDelete(this.data)
    }else{
      const sbChangesDismissed = await this.translateService.instant('delete_not_possible')
      this.userFeedbackService.showSnackBar.emit(sbChangesDismissed)                 
    }
  }


  substractLineWidth(){
    var nlinewidth = Number(this.gOLineTypesForm.value.lineWidth)

    if(nlinewidth>0){
      nlinewidth-=1
      this.gOLineTypesForm.get("lineWidth").setValue(nlinewidth)
    }
  }

  addLineWidth(){
    var nlinewidth = Number(this.gOLineTypesForm.value.lineWidth)
    nlinewidth+=1

    this.gOLineTypesForm.patchValue({lineWidth:nlinewidth})
  }

}
